import { useEffect, useRef } from 'react'

import { TGetItemFn, TPlan, TSetItemFn } from '@/config/types'
import { PageName } from '@/enums/pageName'

import { useAuth } from '@/auth/useAuth'
import { paymentScreenVisitedKey } from '@/core/constants'
import { useSession } from '@/core/session/useSession'
import { trackPageView, trackPaymentScreen } from '@/events/events'

function useTrackPageAndPaymentScreen(
  config: IConfig,
  getItem: TGetItemFn,
  setItem: TSetItemFn,
  pageTitle: string,
  planData: TPlan | undefined,
  pageName: PageName
) {
  const { user } = useAuth()
  const sessionContext = useSession()
  const oneTimeTrack = useRef<boolean>(false)

  useEffect(() => {
    setItem(paymentScreenVisitedKey, new Date().toString())
  }, [setItem])

  useEffect(() => {
    if (oneTimeTrack.current) {
      return
    }
    if (!planData) {
      return
    }
    trackPageView(
      pageName,
      config.PARTNER_ID,
      config.APP_ID,
      config.PAGE_SET_ID,
      sessionContext,
      user,
      [],
      [],
      planData?.internalPlanId
    )
    trackPaymentScreen(
      pageName,
      config.PARTNER_ID,
      config.APP_ID,
      config.PAGE_SET_ID,
      planData?.internalPlanId,
      sessionContext,
      user
    )
    document.title = pageTitle
    oneTimeTrack.current = true
  }, [config, getItem, pageTitle, user, planData, sessionContext, pageName])

  return oneTimeTrack.current
}

export default useTrackPageAndPaymentScreen
